import React from 'react';
import ReactDOM from 'react-dom';
//import registerServiceWorker from './registerServiceWorker';
import {unregister} from './registerServiceWorker';

import { IntlProvider } from 'react-intl';
import { flattenMessages } from './utils/Utils';
import messages from './assets/json/messages';

import MainScreen from './screens/main/MainScreen';

import './index.css';
import 'animate.css/animate.min.css';

let locale = navigator.language.split('-')[0] || 'en';

document.ontouchmove = function(event){
    event.preventDefault();
}

unregister();
ReactDOM.render(
    <IntlProvider locale={locale} messages={flattenMessages(messages[locale])}>
        <MainScreen />
    </IntlProvider>
    , document.getElementById('root')
);
//registerServiceWorker();
